module.exports = __webpack_public_path__ + "static/media/image-5.d02950a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image-5.png
// module id = 432
// module chunks = 0